import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';
import en from './locales/en.json';
import uk from './locales/uk.json';
import de from './locales/de.json';
import es from './locales/es.json';
import az from './locales/az.json';
import tr from './locales/tr.json';
import ky from './locales/ky.json';
import id from './locales/id.json';
import kk from './locales/kk.json';
import hi from './locales/hi.json';
import pt from './locales/pt.json';
import uz from './locales/uz.json';
import { browserLanguages, DEFAULT_LANGUAGE, detectLanguage } from './detectLanguage';

const resources = {
  ru: { translation: ru },
  en: { translation: en },
  uk: { translation: uk },
  de: { translation: de },
  es: { translation: es },
  az: { translation: az },
  tr: { translation: tr },
  ky: { translation: ky },
  id: { translation: id },
  kk: { translation: kk },
  hi: { translation: hi },
  pt: { translation: pt },
  uz: { translation: uz },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectLanguage(browserLanguages(), Object.keys(resources)),
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
